export const objectEqual = (objectA: object | null, objectB: object | null, ignoreType: boolean = false): boolean => {
    if (objectA === objectB) return true; // If they reference the same object
    if (typeof objectA !== "object" || typeof objectB !== "object" || objectA === null || objectB === null) {
        return false; // One or both are not objects or are null
    }

    const keysA = Object.keys(objectA);
    const keysB = Object.keys(objectB);

    if (keysA.length !== keysB.length) return false; // Different number of properties

    for (const key of keysA) {
        if (!objectB.hasOwnProperty(key)) return false; // Key not in both objects

        const valueA = objectA[key];
        const valueB = objectB[key];

        if (typeof valueA === "object" && typeof valueB === "object" && valueA !== null && valueB !== null) {
            if (!objectEqual(valueA, valueB, ignoreType)) return false; // Recursive check for nested objects
        } else if (ignoreType) {
            if (valueA != valueB) return false; // Equality check without type
        } else {
            if (valueA !== valueB) return false; // Strict equality check
        }
    }

    return true;
};

export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

export function deepCopy(obj) {
    if (!isObject(obj)) {
        return obj; // If it's not an object, return the original element
    }

    let copy = {};
    for (let key in obj) {
        if (isObject(obj[key])) {
            copy[key] = deepCopy(obj[key]); // Recursively deep copy object properties
        } else {
            copy[key] = obj[key]; // Copy non-object properties directly
        }
    }
    return copy;
}

export function synchronizeArrays(arrayA, arrayB) {
    const returnArray = [];
    for (let i = 0; i < arrayB.length; i++) {
        const element = arrayB[i];
        const indexInA = arrayA.indexOf(element);

        console.log(element);
        console.log(indexInA);

        if (indexInA === -1) {
            // Element in B not present in A, add it to A
            const copiedElement = deepCopy(element);
            console.log(copiedElement);
            returnArray.push(copiedElement);
        } else {
            returnArray.push(deepCopy(element));
        }
    }

    return returnArray;

    // for (let i = arrayA.length - 1; i >= 0; i--) {
    //     if (!arrayB.includes(arrayA[i])) {
    //         arrayA.splice(i, 1);
    //     }
    // }
}
